import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

export interface H4Props extends HTMLAttributes<HTMLHeadingElement> {}

const H4 = forwardRef<HTMLHeadingElement, H4Props>(
  ({ className, children, ...props }, ref) => {
    return (
      <h4
        ref={ref}
        className={cn(
          'scroll-m-20 text-xl font-semibold tracking-tight',
          className
        )}
        {...props}
      >
        {children}
      </h4>
    );
  }
);

H4.displayName = 'H4';

export { H4 };
